import { reduce } from "lodash";
import React, { useCallback, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { useDataFormatterHook } from "../../../hooks/useDataFormatterHook";
import { decimalInvertedReportFormatter } from "../../fomatters/DecimalFormatter";
import InputSelect from "../InputSelect";
import Report from "../Report";

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function GroupingBalance() {
  const [group, setGroup] = useState("");
  const onGroupChanged = useCallback((g) => setGroup(g), []);
  const { values: groups } = useDataFormatterHook({
    addEmpty: true,
    value: "groupName",
    text: "groupName",
    path: `/Player/Grouping_GetList`,
  });

  const [book, setBook] = useState("");
  const onBookChanged = useCallback((b) => setBook(b), []);
  const { values: books } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/Player/GetBooks`,
  });

  return (
    <div className="flex flex-col gap-4 p-4 h-max">
      <div className="grid grid-cols-2 gap-4">
        <InputSelect
          variant="outlined"
          size="small"
          label="Group"
          name="name"
          data={groups}
          placeholder="DataFormatter"
          setSelectValue={onGroupChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Book"
          name="name"
          data={books}
          placeholder="DataFormatter"
          setSelectValue={onBookChanged}
          startValue={""}
        />
      </div>
      <Report
        title="Grouping Balance Report"
        groupBy="groupName"
        getUrl={() => "/Reports/Report_Grouping_Balance"}
        getParams={({ userId }) => ({
          IdUser: Number(userId),
          Group: group,
          Book: book,
        })}
        getTotals={(data) => ({
          player: "Total",
          currentBalance: reduce(
            data,
            (acc, item) => acc + item.currentBalance,
            0
          ),
        })}
      >
        <TableHeaderColumn dataSort dataField="Id" isKey hidden>
          Id
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="player">
          Player
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="currentBalance"
          dataFormat={decimalInvertedReportFormatter}
        >
          Old Balance
        </TableHeaderColumn>
      </Report>
    </div>
  );
}

export default GroupingBalance;
